<template>
  <div class="container-list">
    <ul class="tab-wrap" v-if="!$route.query.index && $route.query.index !== 0">
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index, tab)"
        v-for="(tab, index) in tabList"
        :key="index"
        v-if="!$store.state.userInfo.tongxin && index >= 7 && index <= 10"
      >
        {{ tab }}
      </li>
    </ul>
    <div class="flex">
      <unitList v-show="$store.state.user.company.cCompanyNum === 'aaa'" @select="getUnit" @getFirst="getOne" :isbim="nowIndex == 8 || nowIndex === 9 ? true : false"></unitList>
      <div class="flex1">
        <tab1 v-if="nowIndex == 0" :cpNum="cpNum"></tab1>
        <tab2 v-if="nowIndex == 1" :cpNum="cpNum"></tab2>
        <tab3 v-if="nowIndex == 2" :cpNum="cpNum"></tab3>
        <tab4 v-if="nowIndex == 3" :cpNum="cpNum"></tab4>
        <tab5 v-if="nowIndex == 4" :cpNum="cpNum"></tab5>
        <tab6 v-if="nowIndex == 5" :cpNum="cpNum"></tab6>
        <tab7 v-if="nowIndex == 6" :cpNum="cpNum"></tab7>
        <tab8 v-if="nowIndex == 7" :cpNum="cpNum"></tab8>
        <tab9 v-if="nowIndex == 8" :cpNum="cpNum"></tab9>
        <tab10 v-if="nowIndex == 9" :cpNum="cpNum"></tab10>
        <tab11 v-if="nowIndex == 10" :cpNum="cpNum"></tab11>
        <tab12 v-if="nowIndex == 11" :cpNum="cpNum"></tab12>
        <tab13 v-if="nowIndex == 12" :cpNum="cpNum"></tab13>
        <tab14 v-if="nowIndex == 13" :cpNum="cpNum"></tab14>
        <tab15 v-if="nowIndex == 14" :cpNum="cpNum"></tab15>
      </div>
    </div>
  </div>
</template>
<script>
import unitList from '@/components/unitList';
import tab1 from './tab1.vue';
import tab2 from './tab2.vue';
import tab3 from './tab3.vue';
import tab4 from './tab4.vue';
import tab5 from './tab5.vue';
import tab6 from './tab6.vue';
import tab7 from './tab7.vue';
import tab8 from './tab8.vue';
import tab9 from './tab9.vue';
import tab10 from './tab10.vue';
import tab11 from './tab11.vue';
import tab12 from './tab12.vue';
import tab13 from './tab13.vue';
import tab14 from './tab14.vue';
import tab15 from './tab15.vue';

export default {
  components: {
    unitList,
    tab1,
    tab2,
    tab3,
    tab4,
    tab5,
    tab6,
    tab7,
    tab8,
    tab9,
    tab10,
    tab11,
    tab12,
    tab13,
    tab14,
    tab15,
  },
  props: ['c_num'],

  data() {
    return {
      nowIndex: 0,
      cpNum: this.c_num || '',
      nowid: '',
      tabList: ['报警系统', '水系统', '电气监控', '视频监控', '消防水泵', '防排烟风机', '无线燃气', '无线烟感', 'bim展示', '违停车辆'],
      company: '',
    };
  },
  created() {
    this.getOne();
    if (this.$route.query.index == 0) {
      this.nowIndex = 8;
    }
  },
  mounted() {},
  watch: {
    c_num(v) {
      this.cpNum = this.c_num;
    },
  },
  methods: {
    changeTab(index, it) {
      this.nowIndex = index;
      this.nowid = it.tr_role_key;
    },
    getOne(val) {
      // alert(val)
      if (this.c_num) {
        this.cpNum = this.c_num;
        return;
      }
      this.cpNum = val;
    },
    getUnit(val) {
      if (this.c_num) {
        this.cpNum = this.c_num;
        return;
      }
      this.cpNum = val;
    },
  },
};
</script>
<style lang="scss">
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
</style>
